module.exports = __webpack_public_path__ + "img/ufly_cloud.da2fd596.png";